(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gat-product-share"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async function(event) {
    const button = event.target.closest('[data-gat-copy]');
    if (!button) return;
    const toolbar = button.closest('.gat-product-share');
    const status = toolbar.querySelector('.gat-product-share__status');
    const label = button.querySelector('[data-copy-text]');
    const fallback = toolbar.querySelector('.gat-product-share__fallback');
    try {
      await navigator.clipboard.writeText(toolbar.dataset.shareUrl);
      fallback.hidden = true;
      label.textContent = toolbar.dataset.copiedLabel;
      status.textContent = toolbar.dataset.copySuccess;
      clearTimeout(button.gatResetTimer);
      button.gatResetTimer = setTimeout(function() {
        label.textContent = toolbar.dataset.copyLabel;
        status.textContent = '';
      }, 4000);
    } catch (error) {
      status.textContent = toolbar.dataset.copyFallback;
      fallback.hidden = false;
      fallback.focus();
      fallback.select();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
